import loadable from '@loadable/component';

export const WistiaScriptLoader = loadable(() => import('./WistiaScriptLoader'), {
  ssr: false,
  cacheKey: () => 'WistiaScriptLoaderComponent'
});